module.exports = __webpack_public_path__ + "static/media/worry-time-large.f089e983.png";